import { useCallback, useEffect, useMemo, useState } from 'react';
import { Column, useGlobalFilter, usePagination, useTable } from 'react-table';
import { AxiosRequestConfig } from 'axios';
import { http } from 'utils';

const useFetchSafe = <T extends object>(
  url: string,
  cols?: Column<T>[],
  config?: AxiosRequestConfig
) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<T[]>([]);
  const columns = useMemo(() => cols || [], [cols]);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await http.get<T[]>(url, config);
      setData(response.data);
    } catch (err:any) {
      setError(err.message || 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  }, [url, config]);

  useEffect(() => {
    fetchData();
    return () => {
      http.cancelAll();
    };
  }, [fetchData]);

  const tableInstance = useTable({ columns, data }, useGlobalFilter, usePagination);

  return { isLoading, error, tableInstance, data, refetch: fetchData };
};

export default useFetchSafe;
